import { render, staticRenderFns } from "./AmoFormComponent.vue?vue&type=template&id=f50759fa&scoped=true"
import script from "./AmoFormComponent.vue?vue&type=script&lang=js"
export * from "./AmoFormComponent.vue?vue&type=script&lang=js"
import style0 from "./AmoFormComponent.vue?vue&type=style&index=0&id=f50759fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50759fa",
  null
  
)

export default component.exports